module.exports = __webpack_public_path__ + "static/img/4-1.c3c9d2e3.png";